import { render, staticRenderFns } from "./ObservationStatus.vue?vue&type=template&id=0cc70544&"
import script from "./ObservationStatus.vue?vue&type=script&lang=js&"
export * from "./ObservationStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports